import React from 'react';
import { bonuses } from '../data/bonuses';
import { CycleMark } from './CycleMark';
export function Bonuses() {
  return <section aria-labelledby="bonuses-heading" className="grid-dark w-full bg-forest-deep" data-id="element-22" data-mp="pio8yn0kl492">
      <div className="mx-auto max-w-5xl px-5 py-14 sm:py-20" data-id="element-23" data-mp="aujz88jhw32f">
        <div className="text-center" data-id="element-24" data-mp="ftmr0ragscsg">
          <p className="eyebrow text-sky" data-id="element-25" data-mp="fsliatgx82dw">Also included at no extra cost</p>
          <h2 id="bonuses-heading" className="rule-underline mt-3 font-display text-[34px] uppercase leading-tight text-paper sm:text-6xl" data-id="element-26" data-mp="1tc05o95my7a">
            Five instant-use <span className="text-ember" data-id="element-27" data-mp="3o2eldqgho70j">bonuses</span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-paper/80" data-id="element-28" data-mp="3t0ohc3a1fbn7">
            The volumes give you the system. These five put it in your van this
            week — forms on your phone, a 7-day start plan, real calls worked
            end to end, units and wiring symbols.
          </p>
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-29" data-mp="3ie6ibiheg3w7">
          {bonuses.map((bonus, i) => <article key={bonus.number} className={`flex flex-col overflow-hidden rounded-2xl border border-forest-line bg-forest ${i === bonuses.length - 1 ? 'sm:col-span-2 sm:mx-auto sm:w-[calc(50%-8px)]' : ''}`} data-id="element-30" data-mp="3dfld14naiu0w" data-mpi={i}>
              {bonus.cover ? <img src={bonus.cover} alt={`${bonus.title} cover`} loading="lazy" className="aspect-square w-full border-b border-forest-line object-cover" data-id="element-31" data-mp="2zfu6foz3sfwx" /> :
          // Portada de respaldo con la identidad del producto
          <div className="grid-light relative flex aspect-[4/3] w-full flex-col justify-between overflow-hidden border-b border-forest-line bg-paper p-5" data-id="element-32" data-mp="nprl7bkw0vmq">
                  <CycleMark className="pointer-events-none absolute -bottom-10 -right-8 h-44 w-44 text-pine/10" data-id="element-33" data-mp="iqorgnacybu2" />
                  <span className={`inline-flex h-14 w-14 items-center justify-center rounded-full font-mono text-xl font-bold text-pine ring-4 ring-paper ${bonus.accent} ${bonus.accent === 'bg-sys-refrig' || bonus.accent === 'bg-bark' ? 'text-white' : ''}`} data-id="element-34" data-mp="3cl95msvkdbrg">
                    {bonus.number}
                  </span>
                  <div className="relative" data-id="element-35" data-mp="2ttq3spda03r0">
                    <span className="text-[10px] font-bold uppercase tracking-[2px] text-bark" data-id="element-36" data-mp="2xu09s212iu5v">
                      Ice Machine Diagnostic Pro · Bonus {bonus.number}
                    </span>
                    <p className="mt-1 font-display text-3xl uppercase leading-none text-pine" data-id="element-37" data-mp="32ra703up8a49">
                      {bonus.title}
                    </p>
                  </div>
                </div>}
              <div className="px-5 pb-6 pt-4" data-id="element-38" data-mp="2f393xagahlw8">
                <div className="flex flex-wrap items-center gap-2" data-id="element-39" data-mp="2f1y0xcuo4i66">
                  <span className="text-[11px] font-bold uppercase tracking-widest text-paper/65" data-id="element-40" data-mp="27k9mvbgaw6g1">
                    Bonus {bonus.number}
                  </span>
                  <span className="rounded bg-ember px-2 py-1 text-[10px] font-bold uppercase tracking-wider text-pine" data-id="element-41" data-mp="22j3u5dmn4j6i">
                    Free today
                  </span>
                </div>
                <h3 className="mt-2.5 font-display text-xl uppercase leading-snug text-paper" data-id="element-42" data-mp="1tmkyvuqxsj6r">
                  {bonus.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-paper/75" data-id="element-43" data-mp="1jtdxsm38bpch">
                  {bonus.body}
                </p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}